import AclAPI from "../../api/acl";
import { getHeaderRequisicao } from "../../helpers";

// Candidato ativo do assessor logado. Mantemos o estado reativo aqui (Vuex) e
// espelhamos em localStorage.equipe, pois grande parte do codigo legado le
// `localStorage.getItem("equipe")` (que nao e reativo).

function getDefaultState() {
  return {
    idcandidato: null,
    nome: "",
    lista: [], // [{ idcandidato, nome_completo, chapa, idmeta }]
  };
}

const state = getDefaultState();

const getters = {
  idcandidato: (state) => state.idcandidato,
  nome: (state) => state.nome,
  lista: (state) => state.lista,
  temMultiplos: (state) => Array.isArray(state.lista) && state.lista.length > 1,
};

const mutations = {
  setLista(state, lista) {
    state.lista = Array.isArray(lista) ? lista : [];
  },
  setCandidato(state, candidato) {
    if (candidato && candidato.idcandidato != null) {
      state.idcandidato = candidato.idcandidato;
      state.nome = candidato.nome_completo || candidato.nome || "";
    } else {
      state.idcandidato = null;
      state.nome = "";
    }
  },
  reset(state) {
    Object.assign(state, getDefaultState());
  },
};

const actions = {
  // Carrega os candidatos atendidos pelo usuario logado e define um candidato ativo
  // inicial (o que ja estiver em localStorage.equipe, senao o primeiro da lista).
  carregarMeusCandidatos: async ({ commit, state }) => {
    try {
      const headers = getHeaderRequisicao();
      const { data } = await AclAPI.getMeusCandidatos(headers);
      const lista = (data && data.candidatos) || [];
      commit("setLista", lista);

      const equipeSalva = localStorage.getItem("equipe");
      let inicial = null;
      if (equipeSalva && equipeSalva !== "null") {
        inicial = lista.find(
          (c) => String(c.idcandidato) === String(equipeSalva)
        );
      }
      if (!inicial && lista.length > 0) {
        inicial = lista[0];
      }
      if (inicial) {
        commit("setCandidato", inicial);
        localStorage.setItem("equipe", inicial.idcandidato);
      }
      return state.idcandidato;
    } catch (e) {
      commit("setLista", []);
      return null;
    }
  },

  // Troca o candidato ativo (chamado pelo seletor no TopBar) e reflete em localStorage.
  setCandidato: ({ commit }, candidato) => {
    commit("setCandidato", candidato);
    if (candidato && candidato.idcandidato != null) {
      localStorage.setItem("equipe", candidato.idcandidato);
    } else {
      localStorage.setItem("equipe", "null");
    }
  },

  limpar: ({ commit }) => {
    commit("reset");
  },
};

export default { namespaced: true, state, getters, mutations, actions };
